// Shared input styling for the error-handling editor (mirrors PropertyField).
export const INPUT_CLASS =
  "w-full px-3 py-2 text-sm border rounded-lg border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500/20 placeholder-slate-400 transition-all";

export const LABEL_CLASS =
  "text-xs font-bold text-slate-500 uppercase tracking-wider";

export const CHIP_CLASS =
  "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-slate-700";
